import { formatApiDate } from '~/shared/lib/date'
import type { FC } from 'react'
import { Box, Typography, Grid } from '@mui/material'
import { SteerageProvider, Steerage } from '~/entities/steerage'

interface MemberSelectedProps {
  steerageProviders: Array<SteerageProvider> | null
  steerage: Steerage | null
}

const selectedProvider = (steerageProviders: SteerageProvider[]): SteerageProvider | undefined => {
  return steerageProviders.find(provider => provider?.member_selected_at != null)
}
const getProviderName = (provider: SteerageProvider): string => {
  if (provider?.first_name != null && provider?.last_name != null)
    return provider.first_name + ' ' + provider.last_name
  return provider.care_organization_name ?? ''
}

const MemberSelectedView: FC<MemberSelectedProps> = props => {
  const steerage = props?.steerage
  const memberSelectedProvider = props.steerageProviders
    ? selectedProvider(props.steerageProviders)
    : undefined

  return (
    <Box sx={{ color: 'text.primary' }}>
      <Grid container spacing={2}>
        <Grid>
          <Typography sx={{ fontSize: '1.2rem', mt: 1 }}>
            Sent to member on{' '}
            {steerage?.locked_at && formatApiDate(steerage?.locked_at, 'MMM dd, yyyy')}
          </Typography>
        </Grid>
        {memberSelectedProvider && <Grid sx={{ mt: 1 }}>{'·'}</Grid>}
        {memberSelectedProvider && (
          <Grid>
            <Typography sx={{ fontSize: '1.2rem', mt: 1 }}>
              Member selected <strong>{getProviderName(memberSelectedProvider)}</strong> on{' '}
              {memberSelectedProvider.member_selected_at &&
                formatApiDate(memberSelectedProvider.member_selected_at, 'MMM dd, yyyy')}
            </Typography>
          </Grid>
        )}
      </Grid>
    </Box>
  )
}

export default MemberSelectedView
